// store/modules/state.user.js
import router from '../../router'
import ServiceLogin from '@/services/service.login'

// Tokens are memory-only. The refresh token lives in an httpOnly cookie the
// browser handles for us, and the access token is replaced on every boot by
// the silent refresh in main.js. Neither is ever written to localStorage.
const state = {
  isAuthenticated: false,
  accessToken: null,
  user: JSON.parse(localStorage.getItem('userData') || 'null')
}

const getters = {
  isAuthenticated: state => !!state.accessToken,
  user: state => state.user,
  accessToken: state => state.accessToken
}

const mutations = {
  SET_AUTHENTICATED (state, accessToken) {
    state.accessToken = accessToken
  },

  SET_USER(state, userData) {
    state.user = userData
    localStorage.setItem('userData', JSON.stringify(userData))
  },

  LOGOUT(state) {
    state.accessToken = null
    state.user = null
    localStorage.removeItem('userData')
  }
}

const actions = {
  login({ commit }, { accessToken, user }) {
    commit('SET_AUTHENTICATED', accessToken)
    commit('SET_USER', user)
  },

  authenticate ({commit}, accessToken) {
    commit('SET_AUTHENTICATED', accessToken)
  },

  async logout({ commit }) {
    try {
      await ServiceLogin.logout()
    } catch (err) {
      console.error('Logout request failed:', err)
    }
    commit('LOGOUT')
    router.push({ name: 'home' })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
